import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';
import { Icon } from 'iovisit-theme/components';
import { useWhishlist } from 'iovisit-theme/helpers';
import { Button } from 'semantic-ui-react';

const messages = defineMessages({
  share_on: {
    id: 'share_on',
    defaultMessage: 'Condividi su',
  },
  add_to_whishlist: {
    id: 'add_to_whishlist',
    defaultMessage: 'Aggiungi alla wishlist',
  },
  remove_from_whishlist: {
    id: 'remove_from_whishlist',
    defaultMessage: 'Rimuovi dalla wishlist',
  },
});

interface WhishlistButtonProps {
  id: string;
  showLabel: boolean;
}

const WhishlistButton: React.FC<WhishlistButtonProps> = ({
  id,
  showLabel = false,
}) => {
  const intl = useIntl();

  const { isInWhishlist, toggleWhishlist } = useWhishlist();
  const inWhishlist = isInWhishlist(id);

  return (
    <Button
      basic
      icon
      title={
        inWhishlist
          ? intl.formatMessage(messages.remove_from_whishlist)
          : intl.formatMessage(messages.add_to_whishlist)
      }
      onClick={() => {
        toggleWhishlist(id);
      }}
      className={cx('add-to-whishlist', {
        'is-in-whishlist': inWhishlist,
      })}
    >
      <Icon prefix={inWhishlist ? 'fas' : 'far'} icon="star" className="icon" />
      {showLabel && (
        <span className="icon-label">
          {inWhishlist
            ? intl.formatMessage(messages.remove_from_whishlist)
            : intl.formatMessage(messages.add_to_whishlist)}
        </span>
      )}
    </Button>
  );
};
export default WhishlistButton;
